import React, { useContext } from "react";
import ReactHtmlParser from "react-html-parser";
import styled from "styled-components";
import { GridColumn, GridRow, Label } from "notes";
import { Field, TimeContext } from "Components";
import { fonts } from "../../../../../../theme/fonts";

export const FormFields = ({
  formData,
  formPart,
  handleChange,
  errors,
  registration,
  ...props
}) => {
  const { body, heading, subHeading, fields, formHeading } = formData;
  const { time } = useContext(TimeContext);

  return (
    <>
      {formPart === 1 ? (
        time < formData.endSweeps ? (
          // content to show before end of sweepstakes
          <>
            {heading && <Heading>{ReactHtmlParser(heading)}</Heading>}
            {subHeading && <SubHeading>{subHeading}</SubHeading>}
            {body && <Body>{ReactHtmlParser(body)}</Body>}
            {formHeading && <FormTitle>{formHeading}</FormTitle>}
          </>
        ) : (
          // content after sweepstakes
          <>
            {heading && <Heading>{ReactHtmlParser(heading)}</Heading>}
            <SubHeading>
              ¡Regístrate y obtén tu ticket gratuito para ver el concierto
              virtual exclusivo por una sola noche con Lenin Ramírez!
            </SubHeading>
          </>
        )
      ) : time < formData.endSweeps ? (
        // before end of sweepstakes
        <>
          <Heading>
            ¡estás Registrado Para El Show! Por Favor Revisa Tu Correo Para
            Encontrar Tu Ticket Gratuito.
          </Heading>
          <SubHeading>
            ¡Responde las siguientes preguntas para tener la oportunidad de
            ganar un meet & greet virtual con Lenin Ramírez y una guitarra
            autografiada!
          </SubHeading>
        </>
      ) : (
        // after sweepstakes ends
        <>
          {heading && <Heading>{ReactHtmlParser(heading)}</Heading>}
          <SubHeading>
            Responde las siguientes preguntas para registrarte al show. ¡Por
            favor revisa tu correo para encontrar tu ticket gratuito!
          </SubHeading>
        </>
      )}

      <Form>
        {fields &&
          fields
            .sort((a, b) => a.order - b.order)
            .filter((field) => {
              if (formPart === 1) {
                return !field.formPart;
              } else if (formPart === 2) {
                return field.formPart === 2;
              }
              return field;
            })
            .map((field, index) => {
              return (
                <FieldContainer fullSize={field.span === "full"} key={index}>
                  {field.type !== "optIn" && !!field.label && (
                    <Label>{field.label}</Label>
                  )}
                  <Field
                    field={field}
                    fieldCheck={
                      !!field.requires ? registration[field.requires] : true
                    }
                    value={registration[field.name]}
                    onChange={(value) => handleChange(value, field.name)}
                    error={{
                      status: errors[field.name],
                      message: "Este valor es requerido.",
                    }}
                  />
                </FieldContainer>
              );
            })}
      </Form>

      {formPart === 1 && time < formData.endSweeps && (
        <p>
          <SweepstakesRulesLink
            href="rules"
            target="_blank"
            rel="noopener noreferrer"
          >
            Reglas Del Sorteo
          </SweepstakesRulesLink>
        </p>
      )}

      {formPart === 2 && (
        <RegistrationDisclaimer>
          Al proporcionar su información, está autorizando a Music Audience
          Exchange a compartir su nombre, correo electrónico y código postal con
          Ford para el uso descrito en{" "}
          <a
            href="https://es.ford.com/help/privacy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Política de Privacidad de Ford
          </a>
          . La recolección y el uso de cualquier información recolectada están
          sujetos a las{" "}
          <a
            href="https://musicaudienceexchange.com/politica-de-privacidad-y-terminos-de-servicio/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Políticas de Privacidad de Music Audience Exchange
          </a>
          .
        </RegistrationDisclaimer>
      )}
    </>
  );
};

const SweepstakesRulesLink = styled.a`
  font-size: 12px;
  color: #626466;
  text-transform: uppercase;
`;

const RegistrationDisclaimer = styled.p`
  font-size: 12px;
  color: #626466;

  a {
    color: #626466;
  }
`;

const Heading = styled.h2`
  font-family: ${fonts.brand.bold};
  font-size: 18px;
  line-height: 20px;
  margin-bottom: 16px;
  text-transform: uppercase;
  color: #4580dd;
`;

const SubHeading = styled.h3`
  font-family: ${fonts.brand.medium};
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 8px;
`;

const Body = styled.p`
  font-family: ${fonts.brand.regular};
  order: 3;
`;

const FormTitle = styled.h3`
  color: #ffffff;
  order: 4;
`;

const Form = styled(GridRow)`
  align-items: flex-start;
  flex-wrap: wrap;
  margin-left: -4px;
  margin-right: -4px;
  order: 5;
`;

const FieldContainer = styled(GridColumn)`
  flex: 0 1 ${(props) => (props.fullSize ? "100%" : "50%")};
  padding: 8px 4px 0 4px;
  width: ${(props) => (props.fullSize ? "100%" : "50%")};
`;
